var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { injectIntl } from "@irati/utils/lang";
import padding from "@irati/ui/src/global/padding";
import { minWidthMedia } from "@irati/ui/src/global/media";
import Flex from "@irati/ui/src/Flex";
import PerksGoOnlinePill from "@irati-web/perksgo/src/components/PerksGoOnlinePill";
import LocationPill from "@irati-web/geolocation/src/components/LocationPill/LocationPill";
var StyledFlex = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ",
    "\n\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " 0px ", " ", ";\n  "], ["\n    padding: ", " 0px ", " ", ";\n  "])), padding.tiny, padding.tiny, padding.base), minWidthMedia.desktop(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 15px 0px 0px ", ";\n  "], ["\n    padding: 15px 0px 0px ", ";\n  "])), padding.base));
var PillsOverlay = function (_a) {
    var deal = _a.deal, isFavouriteDeal = _a.isFavouriteDeal, formatMessage = _a.formatMessage;
    var isPerksGoRetailDeal = deal.isPerksGoRetailDeal, isInStoreDeal = deal.isInStoreDeal;
    if (isFavouriteDeal || (!isPerksGoRetailDeal && !isInStoreDeal)) {
        return null;
    }
    return (React.createElement(StyledFlex, { position: "absolute", width: "190px", justifyContent: "space-between", top: "0", left: "0", padding: "7px 10px 20px 20px" },
        isInStoreDeal && React.createElement(LocationPill, { text: formatMessage({ id: "perks.deal.inStore.text" }) }),
        isPerksGoRetailDeal && React.createElement(PerksGoOnlinePill, { text: formatMessage({ id: "perks.deal.online.text" }) })));
};
export default injectIntl(PillsOverlay);
var templateObject_1, templateObject_2, templateObject_3;
